"use client";

import { useState } from "react";
import "./FAQSection.scss";
import { Col, Container, Row } from "react-bootstrap";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import { FaPlus } from "react-icons/fa6";
import { FaMinus } from "react-icons/fa";

const FAQSection = ({ title = "Frequently Asked Questions", faqData = [] }) => {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (_, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const items = faqData.items || faqData;

  const renderTitle = (text) => {
    if (!text) return null;

    const parts = text.split(/(Questions)/g);

    return parts.map((part, index) =>
      part === "Questions" ? (
        <span key={index} className="highlight">
          {part}
        </span>
      ) : (
        part
      ),
    );
  };

  return (
    <section className="faq-section" id="faq">
      <div className="blur-bg" />
      <Container>
        <Row className="faq-container justify-content-center">
          <Col xxl={8} xl={8} lg={9} className="faq-accordian">
            <h2 className="faq-title">{renderTitle(title)}</h2>

            {items?.map((faq, index) => (
              <Accordion
                key={index}
                expanded={expanded === index}
                onChange={handleChange(index)}
                sx={{
                  boxShadow: "none",
                  borderBottom: "1px solid #ccc",
                  "&.Mui-expanded": {
                    margin: "0px 0",
                    boxShadow: "none",
                  },
                }}
              >
                <AccordionSummary
                  expandIcon={
                    expanded === index ? (
                      <FaMinus className="faq-icon" />
                    ) : (
                      <FaPlus className="faq-icon" />
                    )
                  }
                  aria-controls={`panel${index}-content`}
                  id={`panel${index}-header`}
                  sx={{
                    "& .MuiAccordionSummary-content.Mui-expanded": {
                      margin: "10px 0",
                    },
                  }}
                >
                  <Typography component="span" className="faq-question">
                    {faq.question}
                  </Typography>
                </AccordionSummary>

                <AccordionDetails>
                  {Array.isArray(faq.answer) ? (
                    <ul className="faq-answer">
                      {faq.answer.map((line, index) => (
                        <li key={index}>{line}</li>
                      ))}
                    </ul>
                  ) : (
                    <Typography component="p" className="faq-answer">
                      {faq.answer}
                    </Typography>
                  )}
                </AccordionDetails>
              </Accordion>
            ))}
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default FAQSection;
